<template>
  <div>
    <div class="d-flex align-center ga-2 mb-2">
      <v-icon icon="mdi-account-outline" size="x-small"></v-icon>
      <span class="label mb-0">Виконавець</span>
    </div>
    <employee-autocomplete
      v-model="form.executorId"
      :error-messages="getErrorMessages(v$.executorId)"
      @blur="v$.executorId.$touch()"></employee-autocomplete>
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { getErrorMessages } from 'best-modules/utils'
import EmployeeAutocomplete from '@/components/inputs/employee-autocomplete/EmployeeAutocomplete.vue'
import type { Dialog } from '@/dialog'
import type { IncidentExecutorPayload } from '@/utils/types/incident'

defineOptions({
  name: 'IncidentExecutor',
})

const props = defineProps<{
  dialog: Dialog
}>()

const form = reactive<IncidentExecutorPayload>({
  incidentId: props.dialog.dialogData.incidentId,
  executorId: null,
})

const v$ = useVuelidate(
  {
    executorId: { required },
  },
  form
)
const validationScope = 'incidentExecutor'

const submit = (): IncidentExecutorPayload => {
  return { ...form }
}

defineExpose({
  v$,
  submit,
  validationScope,
})
</script>
